__turbopack_context__.v({
  "amazonGiftCardImage": "amazonGiftCard-module__7drBmG__amazonGiftCardImage",
  "infoBlock": "amazonGiftCard-module__7drBmG__infoBlock",
  "redeemButtonRow": "amazonGiftCard-module__7drBmG__redeemButtonRow",
  "redeemTextRow": "amazonGiftCard-module__7drBmG__redeemTextRow",
  "restrictionsLink": "amazonGiftCard-module__7drBmG__restrictionsLink",
  "restrictionsRow": "amazonGiftCard-module__7drBmG__restrictionsRow",
  "subtitle": "amazonGiftCard-module__7drBmG__subtitle",
});
